import { START_CSV_PROCESSING, END_CSV_PROCESSING } from '../constants/actionTypes';

export const upload = (state = {isProcessing: false}, action) => {
    switch(action.type) {
        case START_CSV_PROCESSING:
            return {
                ...state,
                isProcessing: true
            };
        
        case END_CSV_PROCESSING:
            return {
                ...state,
                isProcessing: false
            };
        
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/uploadCsv.js